import React from 'react';
import styles from './Quantity.module.scss';

interface Props {
  quantity: number,
  handleQtyAdd: () => void,
  handleQtyDeduct: () => void,
  disableTitle?: boolean
}
const Quantity = ({
  quantity, handleQtyAdd, handleQtyDeduct, disableTitle,
}: Props) => (
  <div className={styles.productQty}>
    {disableTitle && <div className={styles.qtyText}>Quantity</div>}
    <div className={`${styles.qtySelectorContainer} ${disableTitle && styles.shadow}`}>
      <div className={styles.qtyDeduct} onClick={handleQtyDeduct} onKeyDown={handleQtyDeduct} role="button" tabIndex={0}>-</div>
      <div className={styles.qty}>{quantity}</div>
      <div className={styles.qtyAdd} onClick={handleQtyAdd} onKeyPress={handleQtyAdd} role="button" tabIndex={0}>+</div>
    </div>
  </div>
);

export default Quantity;
